import styled from 'styled-components';
import { Paragraph } from './index';

export const StyledFormGroupLabel = styled(Paragraph)`
  display: inline-block;
  margin-bottom: .3125rem;
  margin-top: .625rem;
`;
